// 配置文件
// 后台校验暂时用不到这块，所以给一个默认值
export const Properties = {
  os: 'linux',
  browser: 'my_library',
  device: 'my_library',
};
